import { Box } from '@mui/material'
import React from 'react'
import TinyEditorComponent from '../../../../../../components/tiny-editor'
import DOMPurify from 'dompurify'
import { useFormContext } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { SkillBiteEditSlice } from '../../../../../../reducers'

const TinyMCEPageBlock = ({ onChange, index }) => {
  const { watch } = useFormContext()
  const canEdit = useSelector(SkillBiteEditSlice.selectors.selectEditMode)
  const watchBlock = watch(`blocks.${index}`)
  return (
    <Box>
      <TinyEditorComponent
        disabled={!canEdit}
        value={watchBlock?.data?.html}
        name='body'
        setValue={(name, data) => {
          DOMPurify.sanitize(data, {
            USE_PROFILES: {
              html: true,
              svg: true,
              svgFilters: true
            },
            ADD_ATTR: ['target'],
            ADD_TAGS: ['iframe']
          })

          onChange({
            html: data
          })
        }}
      />
    </Box>
  )
}

export default TinyMCEPageBlock
